<template>
	<div class="link-document-item-table">
		<h2 v-if="!!data.setting.title">{{data.setting.title}}</h2>
		<link-document-markdown :value="data.text"/>
	</div>
</template>

<script>

    export default {
        name: "link-document-item-table",
        props: {
            data: {},
        },
    }
</script>

<style lang="scss">
	.link-document-item-table {
		background-color: white;

		& > h2 {
			padding-left: 16px;
		}
	}
</style>
